webpackJsonp([17],{

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(782);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42960d41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(828);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42960d41_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__ = __webpack_require__(366);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      finePlays: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    numberUnReadFineplayApprove: 'masterData/numberUnReadFineplayApprove'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setNavigatorLinks: 'navigator/setLinks',
    setNavigatorTitle: 'navigator/setTitle'
  }), {
    getFineplayGroup: function getFineplayGroup() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var loading, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this.$loading.show();
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api_fine_plays__["a" /* default */].get({ active: false });

              case 4:
                res = _context.sent;

                _this.finePlays = res.data.data;
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

              case 10:
                loading.hide();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    handleOnClickFinePlay: function handleOnClickFinePlay(finePlayId) {
      this.$router.push({ name: 'finePlayApproves.show', params: { finePlayId: finePlayId } });
    }
  }),
  mounted: function mounted() {
    this.setNavigatorLinks([]);
    this.setNavigatorTitle('承認');
    this.getFineplayGroup();
  }
});

/***/ }),

/***/ 828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.numberUnReadFineplayApprove)?_c('div',{staticClass:"fine_plays_approve_page"},_vm._l((_vm.finePlays),function(finePlay){return _c('div',[(finePlay.can_approve)?_c('div',{staticClass:"fine_play_item",on:{"click":function($event){return _vm.handleOnClickFinePlay(finePlay.id)}}},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("dateFormat")(finePlay.created_at)))]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(finePlay.employee.display_name))])]),_vm._v(" "),_c('div',{staticClass:"status",class:{'approval': finePlay.status !== 'preapproval', 'preapproval': finePlay.status === 'preapproval'}},[_vm._v("\n        "+_vm._s(finePlay.status === 'preapproval' ? '未承認' : '申請中')+"\n      ")])]):_vm._e()])}),0):_c('div',{staticClass:"fine_plays_approve_page dont_has_fineplays"},[_c('p',[_vm._v("未承認のファインプレイはありません")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.881a1e2f2a74c51b321e.js